import {EmployeeActionBarEN} from "./employee/en";
import {ApplicationActionBarEN} from "./application/en";
import {DecisionActionBarEN} from "./decision/en";
import {KpiActionBarEN} from "./kpi/en";
import {EmployeeContractActionBarEN} from "./contract/en";
import {AssessmentActionBarEN} from "./assessment/en";

export const ActionBarEN = {
    ...EmployeeActionBarEN,
    ...ApplicationActionBarEN,
    ...DecisionActionBarEN,
    ...KpiActionBarEN,
    ...EmployeeContractActionBarEN,
    ...AssessmentActionBarEN
}